var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettingsBtn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 40,
    viewBox: "0 0 38 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2227_20444)",
    filter: "url(#filter0_d_2227_20444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.95199 4.05304C4.43938 4.05304 4 3.55071 4 2.93676C4 2.35071 4.43938 1.84839 4.95199 1.84839H7.44182C7.46623 1.84839 7.51505 1.84839 7.53946 1.84839C8.41823 1.8763 9.19935 2.07164 9.85842 2.54606C10.5907 3.0763 11.1277 3.8856 11.4207 5.0856C11.4207 5.11351 11.4207 5.14141 11.4451 5.16932L11.6892 6.2856H33.048C33.585 6.2856 34 6.78792 34 7.37397C34 7.4856 33.9756 7.59723 33.9512 7.70885L31.4614 19.1786C31.3637 19.6809 30.9731 20.0158 30.5338 20.0158H14.9113C15.2531 21.467 15.5948 22.2484 16.0586 22.6112C16.62 23.0298 17.5964 23.0577 19.2319 23.0298H19.2563H30.2897C30.8267 23.0298 31.2417 23.5321 31.2417 24.1182C31.2417 24.7321 30.8023 25.2065 30.2897 25.2065H19.2563C17.2303 25.2344 15.9854 25.1786 14.9845 24.4251C13.9593 23.6437 13.4223 22.3042 12.8853 19.8763L9.61432 5.72746C9.61432 5.69955 9.61432 5.69955 9.58991 5.67164C9.44345 5.05769 9.19935 4.63909 8.85761 4.41583C8.51587 4.16467 8.05207 4.05304 7.51505 4.05304C7.49064 4.05304 7.46623 4.05304 7.44182 4.05304H4.95199ZM27.4337 26.4903C28.7274 26.4903 29.7771 27.6903 29.7771 29.1693C29.7771 30.6484 28.7274 31.8484 27.4337 31.8484C26.14 31.8484 25.0903 30.6484 25.0903 29.1693C25.0903 27.6903 26.14 26.4903 27.4337 26.4903ZM17.157 26.4903C18.4508 26.4903 19.5004 27.6903 19.5004 29.1693C19.5004 30.6484 18.4508 31.8484 17.157 31.8484C15.8633 31.8484 14.8137 30.6484 14.8137 29.1693C14.8137 27.6903 15.8633 26.4903 17.157 26.4903ZM12.2262 8.46234L14.3987 17.8112H29.8015L31.8275 8.46234H12.2262Z",
    fill: "black",
    fillOpacity: 0.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2227_20444",
    x: 0,
    y: 0.430664,
    width: 38,
    height: 38.7595,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2227_20444"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2227_20444",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2227_20444"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30.7595,
    fill: "white",
    transform: "translate(4 0.430664)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsBtn);
export default __webpack_public_path__ + "static/media/settingsBtn.71e8965aacb778c0f74d573893772e9a.svg";
export { ForwardRef as ReactComponent };